import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, FormsUtilsService, Task, TaskService, ConfigService } from '../../../../../../core';
import { ConfigEmpresa } from '../../../../../configuracoes/app/empresa';
import { DatepickerComponent } from '../../../../../../shared/components/datepicker';
import { PedidoIntegracaoImportFilter } from '../../../pedido-integracao-import-filter';
import { PedidoIntegracaoErpImportHttpService } from '../pedido-integracao-erp-import-http.service';
import { PedidoIntegracaoErpImportService } from '../pedido-integracao-erp-import.service';
import { Integracao, IntegracaoErpHttpService } from '../../../../../integracao';
import { LocalFaturamento } from '../../../../../local-faturamento/local-faturamento';
import { LocalFaturamentoSelectComponent } from '../../../../../local-faturamento/select';

@Component({
    selector: 'sgt-pedido-integracao-erp-import-modal',
    templateUrl: './pedido-integracao-erp-import-modal.component.html',
    styleUrls: ['./pedido-integracao-erp-import-modal.component.less']
})
export class PedidoIntegracaoErpImportModalComponent implements OnInit {
    configEmpresa: ConfigEmpresa;
    filter: PedidoIntegracaoImportFilter;
    elModal: any;

    @ViewChild('form') form: NgForm;
    @ViewChild('localFaturamentoSelect') localFaturamentoSelect: LocalFaturamentoSelectComponent;
    @ViewChild('datePickerDataEmissaoInicial') datePickerDataEmissaoInicial: DatepickerComponent;
    @ViewChild('datePickerDataEmissaoFinal') datePickerDataEmissaoFinal: DatepickerComponent;
    integracoes: Integracao[];

    constructor(private el: ElementRef,
                private configService: ConfigService,
                private messageService: MessageService,
                private formsUtilsService: FormsUtilsService,
                private taskService: TaskService,
                private integracaoErpHttpService: IntegracaoErpHttpService,
                private pedidoIntegracaoErpImportService: PedidoIntegracaoErpImportService,
                private pedidoIntegracaoErpImportHttpService: PedidoIntegracaoErpImportHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.filter = new PedidoIntegracaoImportFilter();
                this.searchIntegracoes();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Pesquisa as integrações ativas do tipo ERP */
    private searchIntegracoes() {
        try {
            this.integracoes = [];
            this.integracaoErpHttpService.searchAtivas()
                .subscribe(
                    integracoes => {
                        this.integracoes = integracoes;
                        this.setFocus();
                    },
                    (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as integrações ativas do tipo ERP', error)
                );
        } catch (error) {
            this.messageService.error('Erro ao pesquisar as integrações ativas do tipo ERP', 'Erro', error);
        }
    }

    /** Seta o foco no primeiro input após abrir a modal */
    private setFocus() {
        if (this.integracoes?.length === 1) { // Se possuir uma única integração, seta o foco no próximo campo
            this.filter.idIntegracao = this.integracoes[0].id;

            // Se possuir local de faturamento, setamos o foco no local de faturamento
            if (this.configEmpresa.possuiLocalFaturamento) {
                this.localFaturamentoSelect?.setFocus();
            } else { // Se não, seta o foco no número de integração do pedido
                jQuery(this.elModal).find('#importModalnumeroPedidoIntegracao').trigger('focus');
            }
        } else { // Se não, seta o foco no select da integração
            jQuery(this.elModal).find('#importModalIntegracao').trigger('focus');
        }
    }

    /** Obtem a integração informa no array de integrações */
    private getIntegracao(id: number): Integracao {
        return this.integracoes?.find(integracaoFilter => integracaoFilter.id === id);
    }

    private clear() {
        this.filter = null;
    }

    open() {
        this.clear();
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Ao alterar o local de faturamento */
    onChangeLocalFaturamento(localFaturamento: LocalFaturamento) {
        this.filter.codigoIntegracaoLocalFaturamento = localFaturamento?.codigoIntegracaoErpEmpresa ?? null;
    }

    /** Realiza validação do filtro da importação */
    private validateImport(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Data de Emissão
        if (this.filter.dataEmissaoInicial && !this.filter.dataEmissaoFinal) {
            this.messageService.warning('Para importar os pedidos é necessário informar a data de emissão final quando a data de emissão inicial estiver sido informada', 'Filtro Inválido');
            this.datePickerDataEmissaoFinal.setFocus();
            return false;
        } else if (!this.filter.dataEmissaoInicial && this.filter.dataEmissaoFinal) {
            this.messageService.warning('Para importar os pedidos é necessário informar a data de emissão inicial quando a data de emissão final estiver sido informada', 'Filtro Inválido');
            this.datePickerDataEmissaoInicial.setFocus();
            return false;
        }

        // Form Inválido
        if (this.form.invalid) {
            this.messageService.warning('Para importar os pedidos é necessário informar corretamente o filtro', 'Filtro Inválido');
            return false;
        }

        return true;
    }

    /** Realiza a importação */
    import() {
        if (!this.validateImport()) {
            return;
        }

        const integracao = this.getIntegracao(this.filter.idIntegracao);
        const nomeIntegracao = integracao?.nome ?? '';
        const task = new Task(`Importando pedidos do ERP ${nomeIntegracao}`, `Realizando importação dos pedidos do ERP ${nomeIntegracao}`);
        this.taskService.add(task, task.description);
        this.pedidoIntegracaoErpImportHttpService.importMany(this.filter)
            .subscribe(
                (response: any) => {
                    this.taskService.success(task, `Importação dos pedidos do ERP ${nomeIntegracao} realizada com sucesso`);
                    this.pedidoIntegracaoErpImportService.emitAfterImport();
                },
                (error: ApiError) => {
                    this.taskService.error(task, error.message, error.cause, error);
                }
            );

        this.close();
    }
}
